"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL = exports.ACCIONES_MAQUINA_VIRTUAL = exports.ESTATUS_MAQUINA_VIRTUAL = void 0;
exports.ESTATUS_MAQUINA_VIRTUAL = {
    ENCENDIDA: 'POWERED_ON',
    APAGADA: 'POWERED_OFF',
    SUSPENDIDA: 'SUSPENDED',
};
exports.ACCIONES_MAQUINA_VIRTUAL = {
    ENCENDER: 'start',
    APAGAR: 'stop',
    SUSPENDER: 'suspend',
    RESTABLECER: 'reset',
};
exports.ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL = {
    REINICIAR: 'reboot',
    APAGAR: 'shutdown',
};
